import React, { useEffect, useCallback } from 'react'
import cx from 'classnames'
import { useAppDispatch, useAppSelector } from 'reduxTyped'
import { BtnV2, l, Modal } from '@manychat/manyui'

import { setSkipPreviewOnboardingModal } from 'apps/profile/actions/profileActions'
import { closeIgPreviewModal } from 'common/core/actions/uiActions'
import { isSkipPreviewOnboardingModal } from 'common/core/selectors/appSelectors'
import { getInstagramChannel } from 'common/core/selectors/channelSelectors'
import { getPreviewModal } from 'common/core/selectors/uiSelectors'
import BulletListItem from 'components/BulletListItem/BulletListItem'

import cm from './igPreviewModal.module.css'

const VIDEO_URL =
  'https://manychat-storage.s3.eu-central-1.amazonaws.com/manychat/ca/2022/01/20/e2cc8914aab8da56cd31a40a2ad8ae39/reply_message.mp4'

export interface IgPreviewModalProps {
  isShareFlowPage?: true
  isModalOpen?: boolean
  keyword?: string
  previewUsername?: string
  closeModal?: () => void
}

const IgPreviewModal = ({
  isShareFlowPage,
  isModalOpen,
  keyword,
  previewUsername,
  closeModal,
}: IgPreviewModalProps) => {
  const dispatch = useAppDispatch()

  const previewModal = useAppSelector(getPreviewModal)
  const igAccount = useAppSelector(getInstagramChannel)
  const isPreviewModalSkipped = useAppSelector(isSkipPreviewOnboardingModal)

  const previewKeyword = isShareFlowPage ? keyword : previewModal.keyword
  const isOpen = isShareFlowPage ? isModalOpen : previewModal.isOpen
  const igAccountName = isShareFlowPage ? previewUsername : igAccount.username

  const onClose = useCallback(() => {
    if (isShareFlowPage) {
      closeModal?.()
    } else {
      dispatch(closeIgPreviewModal())
    }
  }, [closeModal, dispatch, isShareFlowPage])

  useEffect(() => {
    if (isOpen && !isPreviewModalSkipped) {
      dispatch(setSkipPreviewOnboardingModal(true))
    }
  }, [isOpen, dispatch, isPreviewModalSkipped])

  return (
    <Modal open={isOpen} width={600} onRequestClose={onClose} disableCloseButton noContentPadding>
      <div className="p-x-lg p-y-md">
        <span className="d-block text-display-sm m-b-md">{l.translate('Test your message!')}</span>
        <div className="m-b-lg d-flex justify-center">
          <video className={cx('img-fluid', cm.rounded)} src={VIDEO_URL} loop muted autoPlay />
        </div>
        <BulletListItem n={1} className="m-b-md">
          {l.translate('Open the Instagram app on your phone')}
        </BulletListItem>

        <BulletListItem n={2} className="m-b-md">
          {l.translate(
            'Send a Direct Message with this three-digit code to your <b>@{igAccountName}</b> account from <b>different IG account</b>',
            {
              igAccountName,
            },
          )}
          <div className="bg-default p-y-xxs m-t-xs text-heading-2 text-center rounded">
            {previewKeyword}
          </div>
        </BulletListItem>

        <BulletListItem n={3} className="m-b-lg">
          {l.translate('Wait for the automatic reply message  🎉')}
        </BulletListItem>

        <div className="d-flex justify-center">
          <BtnV2 size="large" variant="primary" onClick={onClose}>
            {l.translate('I Did It!')}
          </BtnV2>
        </div>
      </div>
    </Modal>
  )
}

export default IgPreviewModal
